import { render } from "./RecentArticles.vue?vue&type=template&id=27947cae&scoped=true"
import script from "./RecentArticles.vue?vue&type=script&lang=js"
export * from "./RecentArticles.vue?vue&type=script&lang=js"

import "./recentarticles-responsive.css?vue&type=style&index=0&id=27947cae&scoped=true&lang=css&external"
import "./RecentArticles.vue?vue&type=style&index=1&id=27947cae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27947cae"]])

export default __exports__